import React from 'react';
import { useDrop } from 'react-dnd';

export const BreadcrumbsItem = function Breadcrumbs({ item, goToLevel, isLast }) {
  const [, drop] = useDrop(() => ({
    accept: ['folder', 'form', 'file', 'task', 'task-folder', 'task-form'],
    drop: () => ({ item }),
    collect: (monitor) => ({
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop(),
    }),
  }));
  return (
    <>
      <li ref={item.id || item.url ? drop : null} className={`breadcrumbs-item ${isLast ? 'breadcrumbs-item-last' : ''}`}>
        {/* The crumb itself is passed on as well: a page browsing more than one tree
            needs to know which of them the level belongs to, and an id alone cannot say. */}
        <span className={'cursor-pointer'} onClick={() => goToLevel(item.id ? item.id : item.url, item.id ? 'folder' : 'root', item)}>
          {item.name}
        </span>
      </li>
    </>
  );
};
